import { parseStyle, decodeStyle, mobile, tablet } from "../../../juntion";

function Video({ id, db, gs, device }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    const youtubeVideoID = input.youtubeVideoURL.value
        ? input.youtubeVideoURL.value
        : "rUWxSEwctFU";

    const is_short = input.youtubeVideoURL?.params?.includes("shorts");

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    ...decodeStyle(ps.fixStyle, gs),
                    ...decodeStyle(ps.style, gs),
                    // "&:hover": decodeStyle(ps.hover, gs),
                    ...(tablet(device) && decodeStyle(tabletStyle, gs)),
                    ...(mobile(device) && decodeStyle(mobileStyle, gs)),
                    width: input.videoSize.value,
                    // maxWidth: "100%",
                    alignSelf: input.alignVideo,
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "0px",
                        // paddingBottom: "56.25%",
                        paddingBottom: is_short ? "177%" : "56.25%",
                    }}
                >
                    <iframe
                        title="HelloVideo"
                        src={`//www.youtube.com/embed/${youtubeVideoID}?autoplay=${
                            input.autoplay ? 1 : 0
                        }&modestbranding=1&fs=1&loop=${
                            input.playInLoop ? 1 : 0
                        }${
                            input.playInLoop
                                ? "&playlist=" + youtubeVideoID
                                : ""
                        }&controls=${input.showControls ? 1 : 0}`}
                        frameborder="0"
                        allowfullscreen
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                        }}
                    ></iframe>
                </div>
            </div>
        </div>
    );
}

export default Video;

// Use this for vast experiance
// https://github.com/mediaelement/mediaelement/
